interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  readTime: number;
  likes: number;
  date: string;
  imageUrl: string;
  isHot?: boolean;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  category,
  categorySlug,
  author,
  authorAvatar,
  readTime,
  likes,
  date,
  imageUrl,
  isHot,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer">
      <a href={`/article/${id}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={`${title} - 撸撸社${category}`}
          />
          {isHot && (
            <span className="absolute top-3 right-3 px-2.5 py-1 text-xs font-medium text-background-50 bg-primary-500 rounded-full whitespace-nowrap">
              热门
            </span>
          )}
        </div>
      </a>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2.5">
          <a
            href={`/category/${categorySlug}`}
            className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap hover:bg-primary-100 transition-colors"
          >
            {category}
          </a>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{date}</span>
        </div>
        <a href={`/article/${id}`} className="block">
          <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
            {title}
          </h3>
        </a>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img
              src={authorAvatar}
              alt={author}
              className="w-6 h-6 rounded-full object-cover"
            />
            <span className="text-xs text-foreground-500 whitespace-nowrap">{author}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-time-line"></i>
              {readTime}分钟
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-heart-line"></i>
              {likes >= 1000 ? `${(likes / 1000).toFixed(1)}k` : likes}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
}